<template>
  <b-form-row>
    <b-col cols="12">
      <b-form-checkbox
        v-model="model.render"
        class="pb-1"
      >
        Wrap
      </b-form-checkbox>
      <div
        v-if="model.render"
        class="ml-2"
      >
        <b-form-checkbox v-model="model.showGrid">
          Show grid
        </b-form-checkbox>
        <b-form-checkbox v-model="model.editing">
          Edit
        </b-form-checkbox>
      </div>
    </b-col>
  </b-form-row>
</template>


<script>
import mixinInput from "@frontend/components/input-mixins";

export default {
  name: 'WarpForm',
  mixins: [mixinInput],
  props: {
    isRender: { type: Boolean, default: false },
    showGrid: { type: Boolean, default: false },
    editing: { type: Boolean, default: false }
  },
  emits: ['change'],
  data() {
    return {
      model: {
        render: this.isRender,
        showGrid: this.showGrid,
        editing: this.editing
      }
    };
  },
  computed: {
    computedModel() {
      return Object.assign({}, this.model)
    }
  },
  watch: {
    isRender(val) {
      this.model.render = val;
    },
    showGrid(val) {
      this.model.showGrid = val;
    },
    editing(val) {
      this.model.editing = val;
    },
    computedModel: {
      handler(val, prevVal) {
        if (_.isEqual(val, prevVal)) {
          return;
        }
        this.$emit('change', {
          render: this.computedModel.render,
          editing: this.computedModel.editing,
          showGrid: this.computedModel.showGrid
        });
      },
      deep: true
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

</style>
